import { useState, useMemo, useEffect } from 'react';
import { SchoolsApiContent, SchoolsApi } from 'api';
import { Api } from 'api/cabmun-api-public';
import { useSortableData } from '../../shared/hooks/useSortableData';
import { RowProps, RowSourse } from './models';
import { transformRowProps } from './transformRowProps';

const useActivitiesTableData = (municipalityId: number, isRegion: boolean) => {
  const [loaded, setLoaded] = useState(false);
  const [total, setTotal] = useState<Api.ActivityStatistics.Total & { student_count: number | null }>();
  const [rowsSource, setRowsSource] = useState<RowSourse[]>([]);
  const { items, toggleSort, sortConfig } = useSortableData<RowProps>(
    useMemo(() => rowsSource.map((row) => transformRowProps(row, isRegion)) || [], [rowsSource, isRegion]),
  );

  const setStudentCount = async (schoolId: number | null, value: number) => {
    try {
      await SchoolsApiContent.setUserDataStudentCount({
        subject_id: !schoolId ? municipalityId : 0,
        school_id: schoolId || 0,
        student_count: value,
      });

      if (schoolId) {
        setRowsSource(rowsSource.map((el) => (el.school_id === schoolId ? { ...el, student_count: value } : el)));
      } else {
        setTotal({ ...total!, student_count: value });
      }
    } catch (e) {}
    return;
  };
  useEffect(() => {
    async function fetch() {
      try {
        const [result, userDataResult] = await Promise.all([
          SchoolsApi.getActivityStatistics(),
          SchoolsApiContent.getUserDataStudentCount(),
        ]);
        const municipalityUserData = userDataResult.filter((el) => !el.school_id);

        setTotal({
          ...result.total,
          student_count: municipalityUserData.length ? municipalityUserData[0].student_count! : null,
        });
        const data = userDataResult
          .filter((el) => el.school_id)
          .reduce((acc, el) => {
            return { ...acc, [el.school_id!]: el.student_count || null };
          }, {} as Record<number, number | null>);
        setRowsSource(result.detailed_data.map((el) => ({ ...el, student_count: data[el.school_id || 0] })));
        setLoaded(true);
      } catch (e) {}
    }

    fetch();
  }, []);

  return {
    total: total!,
    items,
    toggleSort,
    setStudentCount,
    loaded,
    sortConfig,
    hasInvolvementLowered: items.some((el) => el.involvementLowered),
  };
};

export default useActivitiesTableData;
